module.exports = __webpack_public_path__ + "static/img/Josiah-Pahulu.9335780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josiah-Pahulu.jpg
// module id = CAIQ
// module chunks = 0